import React, { memo, useState } from 'react';
import { View, StyleSheet, ActivityIndicator } from 'react-native';
import { useQuery, getPageLinkByShortLinkQuery } from '@redlink/services';
import { useNavigation, StackActions } from '@react-navigation/native';
import { useValues } from '@redlink/assets/values';
import { PreviewProductDetail } from './productDetail';
import { PreviewPostDetail } from './postDetail';
import { CompatibleContainer } from '@redlink/components/pages/previewDashboard/compatibleContainer';
import { AddItem } from '@redlink/components/muscles';

export const PreviewPostDetailPage = memo(({ route }) => {
  const { pageName, shortLink } = route.params;
  const { dispatch } = useNavigation();
  const { routes, staticData } = useValues();
  const [isBusy, setIsBusy] = useState(true);

  const {
    data: { PageLinkByShortLink: data = {} },
  } = useQuery(getPageLinkByShortLinkQuery, {
    variables: { pageName, shortLink },
    done: ({ PageLinkByShortLink: data }) => {
      if (data.type === staticData.linkType.innerExternal) {
        window.location.href = data.link.url;
      } else if (
        data.type === staticData.linkType.external &&
        ![
          'avamovie',
          'zarfilm',
          'montmovie',
          'cinemo.org',
          'tinymoviez.com',
          '9movie',
          'FoxMovie',
          'mashhadfilm',
        ].includes(pageName)
      ) {
        window.location.href = data.link.url;
      } else {
        setIsBusy(false);
      }
    },
    failed: (e) => window.location.href = 'https://redl.ink',
  });

  const { type } = data;

  return isBusy ? (
    <View style={styles.container}>
      <ActivityIndicator color="red" size="large" />
    </View>
  ) : type === staticData.linkType.external ? (
    <AddItem onReady={() => (window.location.href = data.link.url)} />
  ) : type === staticData.linkType.product ? (
    <CompatibleContainer>
      <PreviewProductDetail {...{ data, pageName }} />
    </CompatibleContainer>
  ) : (
    <CompatibleContainer>
      <PreviewPostDetail {...{ data, pageName }} />
    </CompatibleContainer>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
